export default __webpack_public_path__ + "static/media/celular.6de2108c.png";